export function doRequest( url, options ) {
	return fetch( url, options )
		.then( response => {
			// Accept:
			if ( response.ok ) {
				return response
			}

			// Reject:
			return new Promise( ( resolve, reject ) => response.text()
				.then( text => {
					reject( text )
				})
			)
		} )
		// Get response based on content type:
		.then( response => {
			const contentType = response.headers.get( 'content-type' )

			if ( contentType && contentType.indexOf( 'application/json' ) !== -1 ) {
				return response.json()
			} else {
				return response.text()
			}
		})
		// Resolve with the response:
		.then( response => {
			return response
		})
		// Reject with the error:
		.catch( error => {
			return Promise.reject( error )
		})
}
